import { Users } from "../../api/account/Users";
import { SystematicProducts } from "../../api/compute/SystematicProducts";
import { deepClone } from "../../deepClone";
import { _prepareUser } from "../../hooks/utils";
import { httpAll } from "../../httpAll";

export const prepareTableData = (chunk: any[]): any[] => {
  let returningArrayOfTuples: any[] = [];
  chunk.forEach((element, index) => {
    let tupla = {};
    tupla["id"] = index;
    tupla["name"] = element?.name;
    tupla["account"] = element?.user?.email;
    tupla["rebalance"] = element?.reviewGranularity;
    tupla["lastRebalanced"] = element?.rebalanceInfo?.last;
    tupla["rebalanceStatus"] = element?.rebalanceInfo?.status;
    returningArrayOfTuples.push(tupla);
  });
  return returningArrayOfTuples;
};
export const systematicPortfoliosGetAutoRebalancing = (params) => {
  const paramsUsersSearch = {
    active: true,
  };

  const userAPI = new Users();
  const systematicAPI = new SystematicProducts();

  return userAPI.getByFilter(paramsUsersSearch).then((responseUserIds) => {
    let autoRebalancingParams = deepClone(params);
    if (autoRebalancingParams == null) {
      autoRebalancingParams = {};
    }
    autoRebalancingParams.userIds = responseUserIds;
    return systematicAPI
      .getAutoRebalancing(autoRebalancingParams)
      .then((response) => {
        var item: any = null;
        var items = response;
        var requests = {
          systematicPortfolios: {},
        };

        for (var i = 0, length = items.length; i < length; i++) {
          item = items[i];
          requests["systematicPortfolios"][item["id"]] = item;
        }

        var paramsUsers = {
          ids: responseUserIds,
          properties: [
            "active",
            "email",
            "firstName",
            "group",
            "lastName",
            "level",
          ],
        };

        requests["users"] = userAPI.get(paramsUsers);

        return httpAll(requests);
      })
      .then((response) => {
        // merging systematic portfolios and rebalance info
        var item: any = null;
        var items: any = [];
        for (let id in response["systematicPortfolios"]) {
          item = response["systematicPortfolios"][id];
          item["rebalanceInfo"] = _decodeRebalanceInfo(
            item["calendarRebalance"]
          );
          delete item["calendarRebalance"];
          items.push(item);
        }

        // merging users with systematic portfolios
        var user: any = null;
        var users = response["users"]["data"][0]["rows"];
        var usersMap = {};
        for (var i = 0, length = users.length; i < length; i++) {
          user = _prepareUser(users[i]);
          usersMap[user["id"]] = user;
        }
        for (let i = 0; i < items.length; i++) {
          item = items[i];
          item["user"] = usersMap[item["ownerId"]];
        }

        // synthetic properties for sorting purposes
        for (let i = 0; i < items.length; i++) {
          item = items[i];
          // console.log(item["rebalanceInfo"]["status"], item);
          item["sortablePropertyEmail"] = item["user"]["email"];
          item["sortablePropertyRebalance"] =
            item["reviewGranularity"].toLowerCase();
          item["sortablePropertyRebalanceLast"] = item["rebalanceInfo"]["last"];
          item["sortablePropertyRebalanceStatus"] =
            item["rebalanceInfo"]["status"] === "overdue"
              ? "2_overdue"
              : item["rebalanceInfo"]["status"] === "rebalance"
              ? "1_rebalance"
              : "0_rebalanced";
        }

        return items;
      });
  });
};
export const _decodeRebalanceInfo = (response) => {
  var data = {
    last: response["rebalance"],
    next: response["nextRebalance"],
    previous: response["previousRebalance"],
    status: response["rebalanceStatus"].toLowerCase(),
    today: response["today"],
  };

  return data;
};

export const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // maxHeight: "600px",
  overflow: "hidden",
  width: "35%",
  bgcolor: "background.paper",
  border: "1px solid #000",
  borderRadius: "4px",
  boxShadow: 5,
  display: "flex",
  gap: 2,
  p: 2,
  flexDirection: "column",
};
